import { ProblemData } from '@gmm/problem';

// Local cache of json data for problems. Starts empty, but as we
// receiveProblems from server, we store state here. Then as students
// mutate the state, this gets updated. Where it gets tricky:
// both problemjs and the student app make changes to this data
// during the attemptSubmitted process.
export const problemJsonMap: Map<string, ProblemData> = new Map();
